const AboutFirstLoad = () => {
  // document?.getElementById("scroll_about")?.scrollIntoView({
  //   behavior: "smooth",
  //   block: "start",
  // });
};
export default AboutFirstLoad;
